// Used to find matching options and clean filter data
export function findStatusByValue(jobStatusOptions, value) {
    if (!Array.isArray(jobStatusOptions)) return undefined;
    return jobStatusOptions.find((r) => r.id === value);
}

// Used to find matching options and clean filter data
export function findTypeByValue(jobTypeOptions, value) {
    if (!Array.isArray(jobTypeOptions)) return undefined;
    return jobTypeOptions.find((r) => r.id === value);
}

// Clean and normalize the DateMath filter object for API requests
export function cleanDateMathFilter(filter, dateMathRange, dateMathSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => [
                k,
                (['jobType', 'jobStatus'].includes(k) && v && typeof v === 'object')
                    ? v.value ?? v.id ?? ''
                    : v,
            ])
            .filter(([_, v]) => v != null && v !== ''),
    );
    filtered.dateMathRange = dateMathRange;
    filtered.dateMathSort = dateMathSort;
    return filtered;
}